module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/otwarcie/big/5-49c4de1acf8b73ff2b990bfd64a14fb7.webp";